import React, { useContext, useEffect, useState } from "react";

import { WarningTooltip } from "@/taskpane/utils/tooltips";
import CrpcenInputCode from "@/taskpane/components/input-code/CrpcenInputCode";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import LoadingButton from "@/taskpane/components/button/LoadingButton";
import { useUpdateCrpcenMutation } from "@/taskpane/services/user.hook";
import { useGetUserAttributesQuery } from "@/taskpane/services/auth.hook";
import { clearSenstiveDataFromLocalStorage } from "@/taskpane/utils/storage";
import { AuthContext } from "@/taskpane/contexts/auth/AuthContext";

export default function CrpcenPage() {
  const [otp, setOtp] = useState("");
  const { tokens } = useContext(AuthContext);
  const hasValidAccessToken = Boolean(tokens?.AccessToken && tokens.AccessToken.length > 0);
  const user = useGetUserAttributesQuery({
    enabled: hasValidAccessToken,
  });
  const [crpcenAsked, setCrpcenAsked] = useState(false);
  const updateCrpcen = useUpdateCrpcenMutation({
    onSuccess: () => {
      setCrpcenAsked(true);
    },
  });

  useEffect(() => {
    if (user.data?.crpcen?.includes("NEED_ACCEPT")) {
      setCrpcenAsked(true);
    }
  }, [user.data]);

  return (
    <Box className="container">
      {crpcenAsked ? (
        <Stack spacing={3} alignItems="center">
          <Card sx={{ margin: "auto", width: "80%" }}>
            <Stack spacing={3} p={2} alignItems="center">
              <Typography
                variant="subtitle1"
                gutterBottom
                color="black"
                fontWeight={600}
                textAlign="center"
                lineHeight={1.4}
              >
                Votre administrateur{" "}
                {updateCrpcen.data?.admin_email && (
                  <>
                    (<i>{updateCrpcen.data?.admin_email || ""}</i>)
                  </>
                )}{" "}
                a reçu une demande d’activation de votre compte.
                <br />
                <br />
                Revenez ici une fois la demande validée.
              </Typography>
            </Stack>
          </Card>
          <Button
            variant="contained"
            onClick={() => {
              clearSenstiveDataFromLocalStorage();
              window.location.reload();
            }}
          >
            Compris
          </Button>
        </Stack>
      ) : (
        <Card sx={{ margin: "auto", width: "80%" }}>
          <Stack spacing={3} p={2} alignItems="center">
            <Typography
              variant="subtitle1"
              gutterBottom
              color="black"
              fontWeight={600}
              textAlign="center"
              lineHeight={1.4}
            >
              Veuillez renseigner le code CRPCEN de votre étude
            </Typography>
            <CrpcenInputCode length={5} onCodeChange={(code) => setOtp(code)} />
            <WarningTooltip title={otp?.length !== 5 ? "Veuillez entrer votre numéro CRPCEN" : ""}>
              <span>
                <LoadingButton
                  disabled={otp?.length !== 5}
                  loading={updateCrpcen.isPending}
                  onClick={() => updateCrpcen.mutate({ crpcen: otp })}
                >
                  Valider
                </LoadingButton>
              </span>
            </WarningTooltip>
          </Stack>
        </Card>
      )}
    </Box>
  );
}
